import Settings from '@/views/Settings/Settings'

export default {
  name: 'Settings',
  mixins: [Settings]
}
